import { render, staticRenderFns } from "./FullscreenContainer.vue?vue&type=template&id=788e3242&scoped=true&"
import script from "./FullscreenContainer.vue?vue&type=script&lang=js&"
export * from "./FullscreenContainer.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenContainer.vue?vue&type=style&index=0&id=788e3242&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788e3242",
  null
  
)

export default component.exports